<template>
  <table-column-element
    v-bind="$attrs"
    v-on="$listeners"
    :align="this.$attrs.align || 'right'"
  >
    <template slot-scope="{row}">
      <number 
        :number="row | get($attrs.prop)"
        :currencySymbol="currencySymbol"
      />
    </template>
  </table-column-element>
</template>

<script>
export default {
  props: {
    currencySymbol: { type: String, default: null },
    tableColumnType: { type: String, default: 'number' }, // новый параметр
  },
  methods: {
    isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-column-number.vue